
const tryParse = (item) => {
  if(Object.prototype.toString.call(item) === '[object String]') {
    try {
      let res = JSON.parse(item)
      return Object.prototype.toString.call(res) === '[object Object]' ? res : item
    } catch (err) {
      // console.error(err, item)
      return item
    }
  }
  if(Object.prototype.toString.call(item) === '[object Number]') return item
  if(Object.prototype.toString.call(item) === '[object Boolean]') return item
  if(Object.prototype.toString.call(item) === '[object Date]') return item
  if(Object.prototype.toString.call(item) === '[object Array]') return [...item]
  if(Object.prototype.toString.call(item) === '[object Null]') return item
  if(Object.prototype.toString.call(item) === '[object Undefined]') return item
  Object.keys(item).forEach((key) => {
    if(item.hasOwnProperty(key)) item[key] = tryParse(item[key])
  })
  return item
}

export const dynamicPropsFn = (router) => ({...tryParse(router.query), ...router.params})



// WEBPACK FOOTER //
// ./src/router/util.js